module.exports = __webpack_public_path__ + "img/eye.6a1bf1f1.svg";